import BaseApi from "./baseAPI";
import { saveAs } from 'file-saver';

class CourseStudentsAPI extends BaseApi{
  get entity() {
    return {
      route: `${this.getCourseId()}/student_courses`,
      name: 'طالب'
    }
  }

  grades(){
      return new Promise((resolve, reject) => {
        return this.request.get(`${this.entity.route}/grades`)
          .then(response => resolve(this.responseWrapper(response)))
          .catch(error => reject(this.errorWrapper(error)))
      })
  }

  enrollRequest(courseId, courseTermId) {
    return new Promise((resolve, reject) => {
      return this.request.post(`${courseId}/student_courses/request`, {course_term_id: courseTermId})
        .then(response => resolve(this.responseWrapper(response)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  unenrollRequest(courseId, courseTermId) {
    return new Promise((resolve, reject) => {
      return this.request.post(`${courseId}/student_courses/unjoin`, {course_term_id: courseTermId})
        .then(response => resolve(this.responseWrapper(response)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  approve(studentId, group) {
    return new Promise((resolve, reject) => {
      return this.request.post(`${this.entity.route}/approve`, {student_id: studentId, group: group})
        .then(response => resolve(this.responseWrapper(response)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  remove(id, group){
    return new Promise((resolve, reject) => {
      return this.request.delete(`${this.entity.route}`, {params:{group:group,student_id:id}})
        .then(response => resolve(this.responseWrapper(response)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  import(data, config){
    return new Promise((resolve, reject) => {
      return this.request.post(`${this.entity.route}/import`, data, config)
        .then(response => resolve(this.responseWrapper(response)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  download(data, name){
    return new Promise((resolve, reject) => {
      return this.request.post(`${this.entity.route}/download`, data, {responseType: 'blob'})
        .then(response => {
          saveAs(new Blob([response.data]), name + '.xlsx')
          resolve(this.responseWrapper(response))
        })
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  downloadTemplate(data, name){
    return new Promise((resolve, reject) => {
      return this.request.post(`${this.entity.route}/download_template`, data, {responseType: 'blob'})
        .then(response => {
          saveAs(new Blob([response.data]), name + '.xlsx')
          resolve(this.responseWrapper(response))
        })
        .catch(error => reject(this.errorWrapper(error)))
    })
  }
}

export default new CourseStudentsAPI()
